import CryptoJS from 'crypto-js';

export const sha256Hash = (message: string): string => {
    return CryptoJS.SHA256(message).toString(CryptoJS.enc.Hex);
};

export const KEY_HASH = '9364b12c11bb71d0cdfdaece69c90aedb4387f695dbd635d4a8fec2b3c9836f0';
